import AbstractComponent from "./abstract-component";


const createTemplate = () => {
  return (
    `<div class="main-footer__wrap container">
      <div class="main-footer__bottom">
        <p class="main-footer__copyright">© 2012—${new Date().getFullYear()}</p>
      </div>
    </div>`
  );
};

export default class FooterLightComponent extends AbstractComponent {
  constructor(className = ``) {
    super();

    this._className = className;
  }

  getTemplate() {
    return createTemplate(this._className);
  }
}
